


























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AjaxHelper } from '@/AjaxHelper';
import { ICourse, ICalendar, ICalendarSession, ICourseMapping, IValidations } from '@/interfaces';
import { getValidationText } from '@/utils';
import { CourseMappingValidator } from '@/validators';

import VSelect from 'vue-select';
import List from '@/components/List.vue';
import ListItem from '@/components/ListItem.vue';
import Field from '@/components/Field.vue';
import Btn from '@/components/Btn.vue';
import BtnGroup from '@/components/BtnGroup.vue';

function blankMapping(): ICourseMapping { return { calendar: null, moodleCourse: null } }

@Component({
  name: 'admin-course-mapping-page',
  components: { Field, VSelect, Btn, BtnGroup, List, ListItem },
  beforeRouteEnter: async (to, from, next) => {
    const moodleCourses = await AjaxHelper.get<ICourse[]>('/moodlecourse');
    const calendars = await AjaxHelper.get<ICalendar[]>('/calendar');
    const mappings = await AjaxHelper.get<ICourseMapping[]>('/coursemapping');
    
    next(vm => {
      (vm as any).moodleCourses = moodleCourses;
      (vm as any).calendars = calendars;
      (vm as any).mappings = mappings;
    });
  }
})
export default class CourseMappingComponent extends Vue {
  public adding = false;
  public saving = false;

  public moodleCourses: ICourse[] = [];
  public calendars: ICalendar[] = [];

  public newModel: ICourseMapping = blankMapping();
  public newModelValidations: IValidations<ICourseMapping> | null = null;
  public newModelShowValidations = false;

  public mappings: ICourseMapping[] = [];

  public selectedMapping: ICourseMapping | null = null;
  public selectedMappingValidations: IValidations<ICourseMapping> | null = null;
  public selectedMappingShowValidations = false;

  public validator = new CourseMappingValidator();
  public getValidationText = getValidationText;

  public get availableMoodleCourses(): ICourse[] { return this.moodleCourses.filter(x => this.mappings.findIndex(y => y.moodleCourse?.id === x.moodleId) === -1); }

  public get filteredMappings(): ICourseMapping[] {
    if (this.newModel.calendar === null && this.newModel.moodleCourse === null) return this.mappings;
    return this.mappings.filter(x => {
      if (this.newModel.calendar === null) return x.moodleCourse?.id === this.newModel.moodleCourse?.id;
      if (this.newModel.moodleCourse === null) return x.calendar?.id === this.newModel.calendar?.id;
      return x.moodleCourse?.id === this.newModel.moodleCourse?.id && x.calendar?.id === this.newModel.calendar?.id;
    });
  }

  public async addMapping() {
    try {
      this.adding = true;
      const validations = this.validator.isValid(this.newModel);
      if (validations === true) {
        this.newModelShowValidations = false;
        this.newModelValidations = null;

        const mapping = await AjaxHelper.post<ICourseMapping, any>('/coursemapping', { moodCourseId: this.newModel.moodleCourse?.id, calendarId: this.newModel.calendar?.id });
        this.newModel = blankMapping();
        this.mappings.push(mapping);
        this.$alert.success('Successfully Added Course Mapping');
      } else {
        this.newModelValidations = validations;
        this.newModelShowValidations = true;
      }
    } catch {
      this.$alert.danger('A Server Error Occured');
    } finally {
      this.adding = false;
    }
  }

  public editMapping(mapping: ICourseMapping) {
    if (this.selectedMapping === null) {
      this.selectedMapping = mapping;
    }
  }

  public async saveMapping() {
    if (this.selectedMapping !== null) {
      try {
        this.saving = true;
        const validations = this.validator.isValid(this.selectedMapping);
        if (validations === true) {
          this.selectedMappingShowValidations = false;
          this.selectedMappingValidations = null;

          const mapping: ICourseMapping = await AjaxHelper.put(`/coursemapping/${this.selectedMapping.id}`, { moodCourseId: this.selectedMapping.moodleCourse?.id, calendarId: this.selectedMapping.calendar?.id });
          const index = this.mappings.indexOf(this.selectedMapping);
          if (index > -1) {
            this.mappings.splice(index, 1, mapping);
          }
          this.cancelMapping();
          this.$alert.success('Successfully Updated Course Mapping');
        } else {
          this.selectedMappingShowValidations = true;
          this.selectedMappingValidations = validations;
        }
      } catch {
        this.$alert.danger('A Server Error Occured');
      } finally {
        this.saving = false;
      }
    }
  }

  public cancelMapping() {
    if (this.selectedMapping !== null) {
      this.selectedMappingShowValidations = false;
      this.selectedMappingValidations = null;
      this.selectedMapping = null;
    }
  }

  @Watch('newModel', { deep: true })
  public onNewModelChange(newModel: ICourseMapping) {
    if (this.newModelShowValidations) {
      const validations = this.validator.isValid(newModel);
      this.newModelValidations = validations === true ? null : validations;
    }
  }

  @Watch('selectedMapping', { deep: true })
  public onSelectedMappingChange(newSelectedMapping: ICourseMapping | null) {
    if (this.selectedMappingShowValidations && newSelectedMapping !== null) {
      const validations = this.validator.isValid(newSelectedMapping);
      this.selectedMappingValidations = validations === true ? null : validations;
    }
  }
}
